<template>
  <DsSnackbar
    :model-value="isSnackbarVisible"
    :action-text="$t('Update.button')"
    @click-action="refreshApp"
  >
    <template #title>
      <p class="tw-ds-text-md">{{ $t('Update.text') }}</p>
    </template>
  </DsSnackbar>
</template>

<script setup lang="ts">
import { useServiceWorkerUpdate } from '@/common/composables/useServiceWorkerUpdate';

const { updateAvailable, refreshApp } = useServiceWorkerUpdate();

const isSnackbarVisible = computed(() => updateAvailable.value);
</script>
